import classNames from "classnames/dedupe";

type Props = {
  logoPath?: string;
  alt?: string;
  className?: string;
};

const useFullyQualifiedUrl = (path: string | undefined): string | undefined => {
  if (!path) return undefined;
  if (path.startsWith("http")) return path;
  if (typeof window === "undefined") return path;

  return new URL(path, window.location.origin).href;
};

export const Logo = ({ logoPath, className, alt }: Props) => {
  const classes = classNames("mobius-quote-details__logo", className);
  const altText = alt ?? "Provider logo";
  const logoUrl = useFullyQualifiedUrl(logoPath);

  if (!logoUrl) {
    return null;
  }

  return <img src={logoUrl} alt={altText} className={classes} />;
};
